export function safeNextPath(value: string | null): string {
  if (value === null || !value.startsWith("/") || value.startsWith("//")) return "/app";
  const allowed = ["/app", "/onboarding", "/space-draft", "/virtual-estimate", "/community", "/cart", "/shop", "/discover", "/account", "/orders", "/search"];
  return allowed.some((path) => value === path || value.startsWith(`${path}?`)) ? value : "/app";
}

export function authRedirectUrl(path: string): string {
  return new URL(path, window.location.origin).toString();
}
